import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=f3b676fa&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b676fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3b676fa')) {
      api.createRecord('f3b676fa', component.options)
    } else {
      api.reload('f3b676fa', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=f3b676fa&scoped=true&", function () {
      api.rerender('f3b676fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W6Tle6s5Zzth/JS/comp/Accordion.vue"
export default component.exports